import createRegExpFromString from "utils/createRegExpFromString";
import PhoneNumberInput from "components/base/PhoneNumberInput/PhoneNumberInput";
import Input from "components/base/Input/Input";
import errorMessage from "constants/errorMessage";
import { EnumPaymentMethodAccountType, PaymentMethodObject } from "types/api/api";
import { Control, FieldErrors } from "react-hook-form";

interface ArgsType {
  selectedPaymentMethod?: PaymentMethodObject | null;
  // eslint-disable-next-line
  i18n: any;
  errors: FieldErrors;
  control: Control;
  // eslint-disable-next-line
  register: any;
}

const renderPaymentMethodInput = ({
  selectedPaymentMethod = null,
  errors,
  i18n,
  control,
  register
}: ArgsType) => {
  if (selectedPaymentMethod) {
    switch (selectedPaymentMethod.accountNumberType) {
      case EnumPaymentMethodAccountType.MSISDN:
        return (
          <PhoneNumberInput
            data-testid="phone-input"
            id="paymentInput"
            control={control}
            rules={{
              required: {
                value: true,
                message: errorMessage.REQUIRED
              },
              pattern: {
                value: createRegExpFromString(selectedPaymentMethod?.validationRegex),
                message: errorMessage.PATTERN
              }
            }}
            name="paymentInput"
            message={errors["paymentInput"] && errors["paymentInput"].message}
            error={!!errors["paymentInput"]}
            label={selectedPaymentMethod?.inputLabel?.find((l) => l.lang === i18n.language)?.text}
          />
        );
      case EnumPaymentMethodAccountType.STRING:
        return (
          <Input
            data-testid="text-input"
            id="paymentInput"
            type="text"
            message={errors["paymentInput"] && errors["paymentInput"].message}
            error={errors["paymentInput"]}
            label={selectedPaymentMethod?.inputLabel?.find((l) => l.lang === i18n.language)?.text}
            {...register("paymentInput", {
              required: {
                value: true,
                message: errorMessage.REQUIRED
              },
              pattern: {
                value: createRegExpFromString(selectedPaymentMethod?.validationRegex),
                message: errorMessage.PATTERN
              }
            })}
          />
        );
      case EnumPaymentMethodAccountType.NUMBER:
        return (
          <Input
            data-testid="number-input"
            id="paymentInput"
            type="number"
            message={errors["paymentInput"] && errors["paymentInput"].message}
            error={errors["paymentInput"]}
            label={selectedPaymentMethod?.inputLabel?.find((l) => l.lang === i18n.language)?.text}
            {...register("paymentInput", {
              required: {
                value: true,
                message: errorMessage.REQUIRED
              },
              pattern: {
                value: createRegExpFromString(selectedPaymentMethod?.validationRegex),
                message: errorMessage.PATTERN
              }
            })}
          />
        );
      default:
        return <Input id="paymentInput" disabled />;
    }
  }
};

export default renderPaymentMethodInput;
